import ServiceAreaPermission from "../../../components/servicePermission/serviceAreaPermission/ServiceAreaPermission"

function ServiceAreaPermissionPage() {
    return (
        <>
            <ServiceAreaPermission />
        </>
    )
}
export default ServiceAreaPermissionPage